package com.cybersoftsolution.cybersoftsolutionweb.utils

object Resources {
    object Images {
        const val brand = "/brand.png"
        const val icoLogo = "/icoLogo.png"
        const val banner = "/banner.png"
        const val bannerSvg = "/banner-img.svg"
        const val favicon = "/favicon.ico"
        const val add_content = "/add_content.png"
        const val app_store = "/app_store.svg"
        const val play_store = "/play_store.svg"
        const val service_web = "/service_web.jpg"
        const val service_app = "/service_app.png"
        const val service_desktop = "/service_desktop.png"
        const val service_server = "/service_server.png"
        const val skills = "/skills.png"
        const val google = "/google_ico.png"
        const val profilePlaceholder = "/profile_placeholder.png"
    }
    object PathIconsVectors { //From https://fontawesome.com/v6/search?
        const val home_ico = "M18.5 44V24H30.5V44M6.5 18L24.5 4L42.5 18V40C42.5 41.0609 42.0786 42.0783 41.3284 42.8284C40.5783 43.5786 39.5609 44 38.5 44H10.5C9.43913 44 8.42172 43.5786 7.67157 42.8284C6.92143 42.0783 6.5 41.0609 6.5 40V18Z"
        const val add_ico = "M24 16V32M16 24H32M10 6H38C40.2091 6 42 7.79086 42 10V38C42 40.2091 40.2091 42 38 42H10C7.79086 42 6 40.2091 6 38V10C6 7.79086 7.79086 6 10 6Z"
        const val list_ico = "M16 12H42M16 24H42M16 36H42M6 12H6.02M6 24H6.02M6 36H6.02"
        const val logOut_ico = "M18 42H10C8.93913 42 7.92172 41.5786 7.17157 40.8284C6.42143 40.0783 6 39.0609 6 38V10C6 8.93913 6.42143 7.92172 7.17157 7.17157C7.92172 6.42143 8.93913 6 10 6H18M32 34L42 24M42 24L32 14M42 24H18"
        const val admin_panel_ico = "\uF7D9" // "M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4l54.1 0 109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109 0-54.1c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7L352 176c-8.8 0-16-7.2-16-16l0-57.4c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144l0 .8 85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    }

    object EditorIconsVectors {
        const val bold_ico = "M16 12H42M16 24H42M16 36H42M6 12H6.02M6 24H6.02M6 36H6.02" //"M0 64C0 46.3 14.3 32 32 32l48 0 16 0 128 0c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128L96 480l-16 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-160L48 96 32 96C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64L112 96l0 128 112 0zM112 288l0 128 144 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0-112 0z"
        const val italic_ico = "M128 64c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-58.7 0L160 416l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l58.7 0L224 96l-64 0c-17.7 0-32-14.3-32-32z"
        const val underline_ico = "M16 64c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 128c0 53 43 96 96 96s96-43 96-96l0-128-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 128c0 88.4-71.6 160-160 160s-160-71.6-160-160L64 96 48 96C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32z"
        const val link_ico = "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
        const val title_ico = "M0 64C0 46.3 14.3 32 32 32l48 0 48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 112 224 0 0-112-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0 48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 144 0 176 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-144-224 0 0 144 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-176L48 96 32 96C14.3 96 0 81.7 0 64z"
        const val code_ico = "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"
        const val image_ico = "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l96 0 32 0 208 0c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    }

    //From https://fontawesome.com/
    object EditorIconsClassName {
        val Bold_ICO : Pair<String,String> = Pair("fa-solid","fa-bold") // "fa-bold"
        val Italic_ICO : Pair<String,String> = Pair("fa-solid","fa-italic") // "fa-italic"
        val Underline_ICO : Pair<String,String> = Pair("fa-solid","fa-underline") //fa-underline"
        val Link_ICO : Pair<String,String> = Pair("fa-solid","fa-link") // "fa-link"
        val Title_ICO : Pair<String,String> = Pair("fa-solid","fa-t") // "fa-t"
        val Heading_ICO : Pair<String,String> = Pair("fa-solid","fa-heading") // "fa-heading"
        val Code_ICO : Pair<String,String> = Pair("fa-solid","fa-code") // "fa-code"
        val Image_ICO : Pair<String,String> = Pair("fa-solid","fa-image") // "fa-image"
        val Youtube_ICO : Pair<String,String> = Pair("fa-brands","fa-youtube") // "fa-youtube"
        val TikTok_ICO : Pair<String,String> = Pair("fa-brands","fa-tiktok") //<i class="fa-brands fa-tiktok"></i>
        val Subtitle_ICO : Pair<String,String> = Pair("fa-solid","fa-subscript") // "fa-subscript"
        val Quote_ICO : Pair<String,String> = Pair("fa-solid","fa-quote-left") // "fa-quote-right"
        val Paragraph_ICO : Pair<String,String> = Pair("fa-solid","fa-paragraph") // "fa-paragraph"
    }

    sealed class FaIconsClassName(val className: String, val icon: String) {
        object Home_ICO : FaIconsClassName("fa-solid", "fa-home")
        object ArrowBack_ICO : FaIconsClassName("fa-solid", "fa-arrow-left")//<i class="fa-solid "></i>
        object Menu_ICO : FaIconsClassName("fa-solid", "fa-bars")
        object VerticalDotts_ICO : FaIconsClassName("fa-solid", "fa-ellipsis-vertical")
        object Search_ICO : FaIconsClassName("fa-solid", "fa-magnifying-glass")
        object Subscribe_ICO : FaIconsClassName("fa-solid", "fa-square-rss")
        //Social
        object Facebook_ICO : FaIconsClassName("fa-brands", "fa-facebook")
        object Instagram_ICO : FaIconsClassName("fa-brands", "fa-instagram")
        object Youtube_ICO : FaIconsClassName("fa-brands", "fa-youtube")
        object Twitter_ICO : FaIconsClassName("fa-brands", "fa-x-twitter")
        object Tiktok_ICO : FaIconsClassName("fa-brands", "fa-tiktok")
        object Linkedin_ICO : FaIconsClassName("fa-brands", "fa-linkedin")
        object Github_ICO : FaIconsClassName("fa-brands", "fa-github")
        object Whatsapp_ICO : FaIconsClassName("fa-brands", "fa-whatsapp")
        object Telegram_ICO : FaIconsClassName("fa-brands", "fa-telegram")

        //Contact
        object Email_ICO : FaIconsClassName("fa-solid", "fa-envelope")
        object Phone_ICO : FaIconsClassName("fa-solid", "fa-phone")
        object Location_ICO : FaIconsClassName("fa-solid", "fa-location-dot")

        //HomeNavMenu
        object AdminPanel_ICO : FaIconsClassName("fa-solid", "fa-screwdriver-wrench")

        object Register_User_ICO : FaIconsClassName("fa-solid", "fa-arrow-right-to-bracket")
        object CirlceCheck_ICO : FaIconsClassName("fa-solid", "fa-circle-check")

        //Profile NavMenu
        object EditProfile_ICO : FaIconsClassName("fa-solid", "fa-user-pen")
        object Password_ICO : FaIconsClassName("fa-solid", "fa-key")
        object ImageProfilePlaceholder_ICO : FaIconsClassName("fa-regular", "fa-circle-user")

    }

    object ImagesWorkFlows {
        const val development="/workflow/development.png"
        const val support="/workflow/support.png"
        const val design="/workflow/design.png"
        const val planing="/workflow/planing.png"
        const val deploy="/workflow/deploy.png"

    }

    object ImagesTech {
        const val flatter="/technologies/flatter.png"
        const val fleet="/technologies/fleet.png"
        const val ktor="/technologies/ktor.png"
        const val delphi="/technologies/delphi.png"
        const val html="/technologies/html.webp"
        const val cshar="/technologies/cshar.jpg"
        const val docker="/technologies/docker.png"
        const val heroku="/technologies/heroku.png"
//        const val archivo_sin_nombre="/technologies/archivo_sin_nombre.DS_Store"
        const val compose="/technologies/compose.png"
        const val apis="/technologies/apis.png"
        const val vultr="/technologies/vultr.png"
        const val hostinger="/technologies/hostinger.png"
        const val oracle="/technologies/oracle.png"
        const val sql="/technologies/sql.png"
        const val win="/technologies/win.png"
        const val github="/technologies/github.png"
        const val wix="/technologies/wix.jpg"
        const val kotlin="/technologies/kotlin.png"
        const val firebase="/technologies/firebase.png"
        const val java="/technologies/java.png"
        const val gcp="/technologies/gcp.png"
        const val aws="/technologies/aws.png"
        const val android="/technologies/android.png"
        const val xml="/technologies/xml.jpg"
        const val cloudflare="/technologies/cloudflare.png"
        const val linux="/technologies/linux.png"
        const val intelij="/technologies/intelij.png"
        const val firebird="/technologies/firebirdlogo.webp"
        const val ccs="/technologies/ccs.png"
        const val kmp="/technologies/kmp.png"
        const val spring="/technologies/spring.png"
        const val visualstudiocode="/technologies/visualstudiocode.png"
        const val androidstudio="/technologies/androidstudioicon.svg.png"
        const val mysql="/technologies/mysql.png"
        const val macos="/technologies/macos.png"
        const val react="/technologies/react.png"


    }

}